require('./bootstrap');


const main = async () => {
    const { default: Vue } = await import(/* webpackChunkName: "vue" */ "vue");
    const { default: PortalVue } = await import(/* webpackChunkName: "vue" */ "portal-vue");
    const { default: DateFilter } = await import(/* webpackChunkName: "vue" */ "./utils/date-filter");


    const { default: Expander } = await import(/* webpackChunkName: "expander" */ "./vue/Expander");

    Vue.component('expander', Expander);
    Vue.use(PortalVue);

    Vue.filter('date', DateFilter);

    const vm = new Vue({
        el: "#page-container",
        components: {
            "booking-component": () => import(/* webpackChunkName: "booking-component" */ "./vue/BookingComponent"),
            "flight-selector": () => import(/* webpackChunkName: "booking-component" */ "./vue/FlightSelector"),
            "content-switch": () => import(/* webpackChunkName: "content-switch" */ "./vue/ContentSwitch"),
            "dropdown": () => import(/* webpackChunkName: "dropdown" */ "./vue/Dropdown"),
            "mobile-menu": () => import(/* webpackChunkName: "mobile-menu" */ "./vue/MobileMenu"),
            "product-map": () => import(/* webpackChunkName: "mobile-menu" */ "./vue/ProductMap"),
            "modal": () => import(/* webpackChunkName: "mobile-menu" */ "./vue/Modal"),
            "product-map-location": () => import(/* webpackChunkName: "mobile-menu" */ "./vue/ProductMapLocation"),
        },
        data: () => ({})
    })
}

const scrollAnimations = () => {
    let e = window.innerHeight / 8 * 7.5;
    let parallax_x_max_move = 1300;
    let t, i;
    for (t = document.getElementsByClassName("parallax-x"), i = 0; i < t.length; i++) {
        var s, n;
        if ((n = (s = t[i]).getBoundingClientRect()).top <= e) {
            var r = n.top / window.innerHeight
                , a = parallax_x_max_move * r;
            a *= -1,
                a += parallax_x_max_move,
                s.style.transform = "translate3d(-" + a + "px, -50%, 0)"
        }
    }
}


const handleHeaderScroll = (e) => {
    const header = document.querySelector('#page-header');
    const logo = header.querySelector('#page-header-logo');
    const secondaryNav = header.querySelector('#page-header-secondary-nav');
    const primaryNav = header.querySelector('#page-header-primary-nav');


    if (window.scrollY > 50) {
        header.classList.add('bg-gray-900')
        logo.classList.remove('md:w-[280px]')
        logo.classList.add('md:w-[180px]')
        secondaryNav.classList.add('opacity-0', 'invisible')
        primaryNav.classList.remove('mt-8')
    } else {
        header.classList.remove('bg-gray-900')
        logo.classList.add('md:w-[280px]')
        logo.classList.remove('md:w-[180px]')
        secondaryNav.classList.remove('opacity-0', 'invisible')
        primaryNav.classList.add('mt-8')
    }
}


const initialise = async function() {
    await main();
    document.addEventListener('scroll', scrollAnimations, {passive: true})

    const { default: EntryAnimations } = await import(/* webpackChunkName: "entry-animations" */ "./utils/entry-animations");
    const { default: imagesLoaded } = await import(/* webpackChunkName: "images-loaded" */ "imagesloaded");
    await import(/* webpackChunkName: "slider" */ "./utils/slider");
    await import(/* webpackChunkName: "slider" */ "./utils/hero-video");



    document.addEventListener('scroll', handleHeaderScroll, {passive: true})

    const listing = document.querySelector('#product-listing-feature');
    if (listing) {
        const buttons = listing.querySelectorAll('[data-target]');

        const activateListing = (button) => {
            buttons.forEach(button => {
                button.classList.remove('button-red')
                button.classList.add('button-outline')
            })
            button.classList.add('button-red')
            button.classList.remove('button-outline')

            const target = listing.querySelector(button.dataset.target);
            target.parentNode.childNodes.forEach(node => {
                if (node.nodeType === 1) {
                    node.classList.remove('block');
                    node.classList.add('hidden');
                }
            })
            target.classList.add('block')
            target.classList.remove('hidden');

        }

        activateListing(buttons[0])

        const listener = (e) => {
            e.preventDefault();
            activateListing(e.currentTarget)
            e.currentTarget.scrollIntoView({behavior:'smooth'})
        }

        buttons.forEach(button => {
            button.addEventListener('click', listener);
        })
    }



    /**
     * Loading screen
     */
    const loadingScreen = document.querySelector('#loading-screen');

    const entryAnimation = new EntryAnimations()
    // imagesLoaded( document.querySelector('#page-container'), ( instance ) => {
        if (loadingScreen) {
            const loadingInner = loadingScreen.querySelector('#loading-screen-inner');
            loadingInner.classList.add('translate-x-full');
            loadingScreen.classList.add('translate-x-full')

            setTimeout(() => {
                entryAnimation.registerObserver();
                loadingScreen.remove()
            }, 1000)
        } else {
            entryAnimation.registerObserver();
        }
    // });





    /**
     * Prerender links
     */

    var links = document.querySelectorAll('a');

    [].forEach.call(links, function(link) {

        link.addEventListener("mouseenter", function() {

            var newPreLoadLink = document.createElement("link");
            newPreLoadLink.rel = "prerender";
            newPreLoadLink.href = link.href;

            document.head.appendChild(newPreLoadLink);
        })

    });

    const mapElements =  document.querySelectorAll('.google-map')

    if (mapElements) {
        const { GoogleMap } = await import(/* webpackChunkName: "google-map" */ "./utils/google-map");
        mapElements.forEach(el => {
            GoogleMap(el);
        })
    }

}

initialise();